import React from 'react';
import PropTypes from 'prop-types';
import { useAgentProfileStore } from '../../../../../store/store';
import HelixSegmentedControl from '../../../common/HelixSegmentedControl';
import { agentProductionTerms as apt } from '../../../../../constants';
import { inventoryTables } from '../../../../constants/agentProductionConstants';

const ForSaleUnderContractToggle = ({ mlsName }) => {
    const {
        setInventoryTableType,
        inventoryTableType,
    } = useAgentProfileStore(state => ({
        setInventoryTableType: state.setInventoryTableType,
        inventoryTableType: state.inventoryTableType,
    }));
    
    const handleTableTypeChange = (tableStatus) => {
        setInventoryTableType(tableStatus);
    };

    const options = [
        { value: apt.forSaleListing, label: inventoryTables.FOR_SALE },
        { value: apt.underContractListing, label: inventoryTables.UNDER_CONTRACT }
    ];

    return (
        <div className="d-flex align-items-center">
            <span className="mr-3">{mlsName}</span>
            <HelixSegmentedControl
                setOption={handleTableTypeChange}
                optionsList={options}
                defaultOption={inventoryTableType}
            />
        </div>
    );
}

ForSaleUnderContractToggle.propTypes = {
    mlsName: PropTypes.string,
};

export default ForSaleUnderContractToggle;
